import {FedeltaImageData} from '@fedelta-pos/data-client';

export function titleCase(str: string) {
    return str.trim().split(/\s+/).map((s) => s[0].toUpperCase() + s.slice(1).toLowerCase()).join(" ");
}

export function quote(s: string | number): string {
    return "'" + s + "'";
}

export function isNumber(s: string): boolean {
    return /^\d+$/.test(s);
}

export function toScale(n: number, scale: number): string {
    return n == undefined ? undefined : n.toFixed(scale).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, "$1");
}

export function uuid(): string {
    let d: string = "";
    while (d.length < 32) {
        d += Math.random().toString(16).substring(2);
    }
    const vr: string = ((parseInt(d.substring(16, 17), 16) & 0x3) | 0x8).toString(16);
    return `${d.substring(0, 8)}-${d.substring(8, 12)}-4${d.substring(13, 16)}-${vr}${d.substring(17, 20)}-${d.substring(20, 32)}`;
}

export function span(className: string, id: string, content: string | number): string {
    return "<span class='" + className + "' id='" + id + "'>" + content + "</span>";
}

export function isFedeltaImageData(value: unknown): value is FedeltaImageData {
    return value instanceof FedeltaImageData || (typeof value === "object" && value !== null && "id" in value);
}

export function xmur3(input: string): () => number {
    let h: number = 1779033703 ^ input.length;

    for (let i: number = 0; i < input.length; i++) {
        h = Math.imul(h ^ input.charCodeAt(i), 3432918353);
        h = (h << 13) | (h >>> 19);
    }

    return (): number => {
        h = Math.imul(h ^ (h >>> 16), 2246822507);
        h = Math.imul(h ^ (h >>> 13), 3266489909);
        h ^= h >>> 16;
        return h >>> 0;
    };
}

export function mulberry32(seed: number): () => number {
    return (): number => {
        let t: number = (seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;    };
}
